import { Component, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../../components/button/button.component';
import { HeaderComponent } from '../../components/header/header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { EdgeFunctionCallerService } from '../../services/edge-function-caller.service';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { PsychologistService } from '../../services/psychologist.service';
import { Psychologist } from '../../models/psychologists';
import { Router } from '@angular/router';
import TYPES from '../../constants/types';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-premium-feature',
  imports: [
    TranslatePipe,
    ButtonComponent,
    HeaderComponent,
    LoadingComponent
  ],
  templateUrl: './premium-feature.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './premium-feature.component.scss',
})
export class PremiumFeatureComponent {

  country:WritableSignal<string> = signal<string>('');
  edgeFunctionsCallerService: EdgeFunctionCallerService = inject(EdgeFunctionCallerService);
  authService: AuthService = inject(AUTH_SERVICE);
  psychologistService: PsychologistService<Psychologist> = inject(PsychologistService);
  loading: WritableSignal<boolean> = signal(false);

  BUTTON_TYPES: any;
  PLANS: any;

  constructor(private router: Router){
    this.BUTTON_TYPES = TYPES.UI.BUTTON;
    this.PLANS = TYPES.DATABASE.PLANS;
  }

  async choosePlan(plan:string){
    if(plan === this.PLANS.STARTER.code){
      this.router.navigate(['/home'], {replaceUrl: true});
    }else if(plan === this.PLANS.PROFESSIONAL.code){
      const userEmail = this.authService.user()?.email;
      const userName = this.authService.user()?.first_name + ' ' + this.authService.user()?.last_name || '';
      if(userEmail){
        this.loading.set(true);
        if(this.psychologistService.psychologist()?.vip){
          await this.edgeFunctionsCallerService.startVIPSubscription(userEmail, userName, environment.STRIPE_PRICE_PLANS.PROFESSIONAL_FREE);
          this.router.navigate(['/info/sub_done/info.thank_you/info.sub_done/info.enjoy/buttons.continue'], {replaceUrl: true});
        }else{
          this.edgeFunctionsCallerService.startSubscription(userEmail, userName, environment.STRIPE_PRICE_PLANS.PROFESSIONAL);
        }
      }
    }
  }

  back(){
    history.back();
  }

}
